import MeaPage from "../../../components/MeaPage";
import { useRef } from "react";
import CoursesListComponent from "./components/CoursesListComponent";

const CoursesListPage = () => {
  //
  const listRef = useRef();
  //
  return (
    <>
      <MeaPage
        //breadcrumb={<SlotsBreadCrumb />}
        title="Liste des matières"
        subtitle="Gérer l'ensemble des matières de cette formation"
      >
        <CoursesListComponent
          ref={listRef}
          showAddButton={true}
          showFilterButton={true}
        />
      </MeaPage>
    </>
  );
};
export default CoursesListPage;
